<template>
    <div
        v-if="toggleBtn"
        class="alert-area"
    >
        <div
            class="alert alert-dismissible"
            :class="alertData.class"
            role="alert"
        >
            <button
                type="button"
                class="close"
                data-dismiss="alert"
                aria-label="Close"
                @click="close"
            >
                <span aria-hidden="true">&times;</span>
            </button>

            <p>
                <i
                    :class="'fa-' + icons[alertData.class]"
                    class="icon fa"
                />
                <span v-html="alertData.message" />
            </p>

            <ul
                v-if="alertData.errors"
                style="margin-top: 10px"
            >
                <li
                    v-for="(error, idx) in alertData.errors"
                    :key="idx"
                >
                    {{ error[0] }}
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
import EventBus from '../../event-bus';

export default {
    data() {
        return {
            toggleBtn: false,
            alertData: {},
            icons: {
                'alert-success': 'check',
                'alert-danger': 'ban',
            },
        };
    },
    mounted() {
        EventBus.$on('alertData', (data) => {
            this.alertData = data;
            this.toggleBtn = true;
        });

        EventBus.$on('alertOptions', (data) => {
            if (this.alertData) {
                this.toggleBtn = data.displayAlert;
            }
        });
    },
    methods: {
        close() {
            this.toggleBtn = false;
            this.$emit('close');
        },
    },
};
</script>
